import styled from 'styled-components';

const Bar = styled.div<{ $color?: string; $percentage?: number }>`
    width: ${props => 78 * (props.$percentage ?? 0)}px;
    background-color: ${props => props.$color};
    height: 5px;
    border-radius: 2px;

    transition: width 350ms ease;

    &:not(:first-child) {
        margin-left: 4px;
    }
`;

export default Bar;
